/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Combinazione logica del predicato con il precedente
 */
export enum LogicaJoin {

    AND = 'AND',

    OR = 'OR'
}

